import useStore from '@/stores/useStore';

/**
 * Cleans up Zustand video session state before navigation.
 * Should be called before navigating away from a video session.
 */
export function cleanupVideoSessionState(): void {
  const { setIsInSession, setActiveSessionName } = useStore.getState();
  setIsInSession(false);
  setActiveSessionName('');
}
